import { useParams, useNavigate } from 'react-router-dom';
import { Pageheader } from './global-components/page-header';
import { FaArrowLeft, FaCalendar, FaUser } from 'react-icons/fa';
import './BlogDetail.css';
import bgImage from '../assets/img/banner/contact.webp';
import { blogData } from '../constants/blogData';

const BlogDetail = () => {
    const { id: slug } = useParams(); // Using 'id' param as 'slug' from route
    const navigate = useNavigate();

    // Find the post by slug or by ID (to maintain compatibility if needed)
    const post = blogData.find(p => p.slug === slug || String(p.id) === String(slug));

    if (!post) {
        return (
            <div>
                <Pageheader headertitle="Blog Post Not Found" bgImage={bgImage} />
                <div className="container" style={{ padding: '80px 20px', textAlign: 'center' }}>
                    <h2>Post not found</h2>
                    <button onClick={() => navigate(-1)} className="back-button">
                        <FaArrowLeft /> Go Back
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Pageheader headertitle={post.title} bgImage={bgImage} />
            <div className="blog-detail-section">
                <div className="container">
                    <button onClick={() => navigate(-1)} className="back-button">
                        <FaArrowLeft /> Back to News
                    </button>

                    <div className="blog-detail-content">
                        <div className="blog-detail-header">
                            <span className="blog-category">{post.category}</span>
                            <h1>{post.title}</h1>
                            <div className="blog-meta">
                                <span><FaCalendar /> {post.date}</span>
                                <span><FaUser /> {post.author || "Royale Spaces"}</span>
                            </div>
                        </div>

                        <div className="blog-detail-image">
                            <img src={post.image} alt={post.title} />
                        </div>

                        <div className="blog-detail-body">
                            {post.content.split('\n\n').map((paragraph, index) => {
                                // Highlight numbered headings like "1. Heading"
                                const highlightedContent = paragraph.replace(/^(\d+)\.\s(.+)$/gm, (match, num, heading) => {
                                    return `<span style="color:#d8b035;font-weight:800;font-size:1.15em;display:block;margin-top:1.2em;margin-bottom:0.8em;">${num}. ${heading}</span>`;
                                });

                                return (
                                    <p key={index}
                                        style={{ whiteSpace: 'pre-line', marginBottom: '1.5em' }}
                                        dangerouslySetInnerHTML={{ __html: highlightedContent }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogDetail;
